import React from 'react';
var TriggerContext = React.createContext(null);
export default TriggerContext;


//////////////////
// WEBPACK FOOTER
// ./~/rc-trigger/es/context.js
// module id = 2067
// module chunks = 0